import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { EventType } from '../../../types';
import useStyles from './styles';

interface CardBannerProps {
  offeringType: EventType;
  eventTypeLabel: string;
}

const CardBanner = ({ offeringType, eventTypeLabel }: CardBannerProps) => {
  const classes = useStyles({
    offeringType,
  });

  return (
    <Box className={classes.header}>
      <Typography variant="body1" className={classes.headerLabel}>
        {eventTypeLabel}
      </Typography>
    </Box>
  );
};

export default CardBanner;
